import { tr, trf } from './i18n';

/**
 * La convention de formation, dans la langue de l'entreprise : chaque phrase
 * passe par le dictionnaire. Écrite d'un bloc, elle restait en français, la
 * traduction de l'écran ne reconnaissant pas un texte aussi long.
 */
export function genConvention(emp, f, soc) {
  emp = emp || {};
  f = f || {};
  soc = soc || {};
  const nom = ((emp.prenom || '') + ' ' + (emp.nom || '')).trim() || tr('Le travailleur');
  const adrE = [emp.adresse, [emp.npa, emp.ville].filter(Boolean).join(' ')]
    .filter(Boolean)
    .join(', ');
  const adrS = [soc.adr, soc.npa].filter(Boolean).join(', ');
  const cout = +f.cout || 0;
  const eng = +f.engagementMois || 24;
  const mens = f.mensualite !== undefined ? f.mensualite : 500;
  const av = emp.avs ? ' ' + trf('(N° AVS {0})', emp.avs) : '';
  const fonc = emp.role ? trf(', en qualité de {0}', emp.role) : '';
  const L = [];
  L.push(tr('Entre les soussignés :'));
  L.push('');
  L.push(
    (soc.nom || tr("L'employeur")) +
      (adrS ? ', ' + adrS : '') +
      (soc.tva ? ' ' + trf('(IDE {0})', soc.tva) : ''),
  );
  L.push(tr("ci-après « l'employeur »,"));
  L.push('');
  L.push(tr('et'));
  L.push('');
  L.push(
    nom +
      (adrE ? ', ' + adrE : '') +
      av +
      (emp.dateEmbauche ? trf(', engagé(e) le {0}', emp.dateEmbauche) : '') +
      fonc,
  );
  L.push(tr('ci-après « le travailleur »,'));
  L.push('');
  L.push(tr('il est convenu ce qui suit :'));
  L.push('');
  L.push(tr('Art. 1 — Objet'));
  L.push(
    f.debut
      ? trf(
          "L'employeur finance la formation « {0} » pour un coût total de {1} CHF (frais de formation et salaire versé pendant les jours de cours), débutant le {2}.",
          f.nom || '…',
          cout,
          f.debut,
        )
      : trf(
          "L'employeur finance la formation « {0} » pour un coût total de {1} CHF (frais de formation et salaire versé pendant les jours de cours).",
          f.nom || '…',
          cout,
        ),
  );
  L.push('');
  L.push(tr('Art. 2 — Engagement'));
  L.push(
    trf(
      "Le travailleur s'engage à rester au service de l'employeur pendant {0} mois dès la fin de la formation.",
      eng,
    ),
  );
  L.push('');
  L.push(tr('Art. 3 — Remboursement dégressif'));
  L.push(
    trf(
      'En cas de départ anticipé (démission ou licenciement pour faute grave), le travailleur rembourse le coût de la formation par mensualités de {0} CHF. Le montant dû diminue proportionnellement au temps de service déjà accompli.',
      mens,
    ),
  );
  L.push('');
  L.push(tr('Art. 4 — Exceptions'));
  L.push(
    tr(
      "Aucun remboursement n'est dû si le contrat prend fin pour un motif non imputable au travailleur (licenciement sans faute de sa part, motif économique, fin de CDD).",
    ),
  );
  L.push('');
  L.push(tr('Art. 5 — Divers'));
  L.push(
    tr(
      'Toute modification se fait par écrit. La présente convention complète le contrat de travail et est établie en deux exemplaires, dont un remis à chaque partie.',
    ),
  );
  L.push('');
  L.push(tr('Convention soumise au droit suisse (art. 319 ss CO).'));
  return L.join('\n');
}

// Le texte proposé du certificat, dans la langue de l'entreprise : il se
// place dans le champ de saisie, que la traduction de l'écran ne touche pas.
export const CERT_TXT_DEF = (emp) =>
  trf(
    "Durant cette période, {0} a exécuté les tâches liées à sa fonction avec sérieux, compétence et engagement, à notre entière satisfaction. Son comportement, tant à l'égard de la direction que de ses collègues et de la clientèle, a toujours été exemplaire.",
    (emp && emp.nom) || tr("l'employé·e"),
  ) +
  '\n\n' +
  tr(
    'Nous le·la remercions pour la qualité de son travail et pour sa collaboration, et lui adressons nos meilleurs vœux de succès pour la suite de son parcours professionnel.',
  );
